import React from "react";

interface ChevronRightProps {
  width?: number;
  height?: number;
  className?: string;
  fill?: string;
}

const ChevronRight: React.FC<ChevronRightProps> = ({
  width = 10,
  height = 16,
  className = "",
  fill = "#1C1C1C",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 10 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M6.20026 8L0.0669269 1.86667L1.93359 -3.54417e-07L9.93359 8L1.93359 16L0.0669263 14.1333L6.20026 8Z"
        fill={fill}
      />
    </svg>
  );
};

export default ChevronRight;
